import { Immutable } from "immer";
import React from "react";

import { IImageURL } from "../../models/nominals";

type ImgProps = React.DetailedHTMLProps<
    React.ImgHTMLAttributes<HTMLImageElement>,
    HTMLImageElement
>;

type IProps = Immutable<
    Pick<ImgProps, "alt" | "className" | "crossOrigin"> & {
        "lazy"?: boolean;
        // `data-src` retained as an accepted prop for call-site compat; it is
        // coalesced into `src` since native lazy loading needs a real src.
        "data-src"?: IImageURL | string;
        "src"?: IImageURL | string;
    }
>;

export const Image = (props: IProps): React.JSX.Element => {
    const src = props.src ?? props["data-src"];
    return (
        <img
            alt={props.alt}
            className={props.className}
            crossOrigin={props.crossOrigin}
            src={src ? `${src}` : undefined}
            loading={props.lazy === false ? "eager" : "lazy"}
            decoding="async"
        />
    );
};
